module.exports = __webpack_public_path__ + "img/choco-shake-vignette.5c2fb9f6.jpg";